<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/products" v-on:click="sendMsg">产品中心</a></li>
            <li><a href="/#/vibrate" v-on:click="sendMsg">振动传感器系列</a></li>
            <li class="active">891-2</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">891-2</h1>
            <hr>
            <img src="../../../assets/product/vibrate/BY_S07/BY-S07.png" alt="" style="width: 50%; display: block; margin: auto;">
            <p class="titleP">产品功能概述</p>
            <p>广泛用于桥梁、隧道、大坝、海洋平台、水轮发电机组的振动测量</p><br>
            <p class="titleP">技术特点</p>
            <p>加速度低频至0.8Hz、速度低频至0.4Hz</p>
            <p>无源型传感器，环境适应性强</p>
            <p>体积小、重量轻</p>
            <p class="titleP">主要技术指标</p>
            <img src="../../../assets/product/vibrate/BY_S07/index1.png" alt="" style="width: 50%; display: block; margin: auto;">
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/vibrate/891_2.vue